(ns fen.command
  "What can be done here, and doing it.

  Between the popup that lists the offers and the keyboard that picks one:
  both need the same offers in the same order, and neither of them owns the
  list. What an action asks for is part of the action, so running one is the
  same three lines whichever way it was reached.

  The asking is a dialog of the window's own (see fen.screen/Ask). It used
  to be `js/prompt`, on purpose, until the data had proven it carried
  enough - and a browser's prompt is the one thing a phone in its own
  window draws badly. What an action wants is still read from the action:
  this file learned nothing new when the box changed."
  (:require [fen.window :as window]))

(defn- row-of [screen handle]
  (when handle (first (filter #(= handle (:handle %)) (:rows screen)))))

(defn offered
  "Everything the popup offers, in the order it shows them: what this row can
  do, and after it what the entity itself can do.

  The entity's are always at the bottom, because on a row that came with the
  program they are the only ones there are - and a popup that can do nothing
  but say no is a dead end. Each offer carries the handle it belongs to,
  since that is what tells the server whether it is about the one row or
  about the whole entity (see ento.presenter)."
  [screen {:keys [handle]}]
  (let [row (row-of screen handle)]
    (-> []
        (into (map (fn [a] {:handle handle :action a :group (:label row)}))
              (:actions row))
        (into (map (fn [a] {:handle nil :action a :group (or (:title screen) "this entity")}))
              (:actions screen)))))

(defn- send! [{:keys [handle action]} given]
  (window/send! {:type :act :handle handle :action (:id action) :input given}))

(defn act!
  "Do it: ask for whatever it wants, then send it.

  The popup closes first. It was opened to pick one thing and one thing has
  been picked - what happens next is the action's question, if it has one,
  and that is asked in a box of its own."
  [{:keys [action] :as offer}]
  (window/close-menu!)
  (if (:input action)
    (window/ask! offer)
    (send! offer nil)))

(defn answer!
  "The question answered. Text for an action that wanted text, nil for a
  yes - a confirmation carries no value, only that it was given. An empty
  string is still an answer: it clears a key or empties a value, and that is
  a thing a person can mean (see ento.presenter)."
  [offer given]
  (window/close-ask!)
  (send! offer given))

(defn cancel!
  "The question left unanswered. Nothing is sent: a cancelled box changes
  nothing, and the row is as it was."
  []
  (window/close-ask!))
